import { SxProps } from '@mui/system'
import { theme } from 'src/providers/ThemeProvider'

type SearchBoxElements = {
  search: SxProps
}

export const searchBoxStyles: SearchBoxElements = {
  search: {
    width: theme.spacing(50)
  }
}
